$(document).ready(function () {
  const introTitleFirst = $('.intro__title span:first-of-type')
  const introTitleSecond = $('.intro__title span:nth-of-type(2)')
  const introLine = $('.intro__line')

  const allWords = [
    $('.intro-word--3'),
    $('.intro-word--1'),
    $('.intro-word--2'),
    $('.intro-word--4'),
    $('.intro-word--5'),
    $('.intro-word--6'),
    $('.intro-word--7'),
  ]

  let mainTimeline

  function animateWord(word, delay = 0) {
    const wordTl = gsap.timeline()
    const lines = word.find('.intro-word__line')
    const text = word.find('.intro-word__text')

    wordTl.to(word, { opacity: 1, duration: 0.1 }, delay)

    lines.each(function (index) {
      const line = $(this)
      const lineWidth = parseFloat(line.css('width')) || 0
      const lineHeight = parseFloat(line.css('height')) || 0
      const isVertical = lineHeight > lineWidth

      if (isVertical) {
        wordTl.to(
          line,
          {
            scaleY: 1,
            duration: 0.5,
            ease: 'power2.out',
          },
          delay + 0.1 + index * 0.3
        )
      } else {
        wordTl.to(
          line,
          {
            scaleX: 1,
            duration: 0.5,
            ease: 'power2.out',
          },
          delay + 0.1 + index * 0.3
        )
      }
    })

    const linesDelay = delay + 0.1 + lines.length * 0.3 + 0.2
    wordTl.to(
      text,
      {
        opacity: 1,
        y: 0,
        duration: 0.4,
        ease: 'back.out(1.7)',
      },
      linesDelay
    )

    return wordTl
  }

  function hideAllWords(delay = 0) {
    const hideTl = gsap.timeline()

    allWords.forEach((word) => {
      const lines = word.find('.intro-word__line')
      const text = word.find('.intro-word__text')

      hideTl.to(
        text,
        {
          opacity: 0,
          y: -10,
          duration: 0.4,
          ease: 'power2.in',
        },
        delay
      )

      hideTl.to(
        lines,
        {
          scaleX: 0,
          scaleY: 0,
          duration: 0.3,
          ease: 'power2.in',
        },
        delay + 0.1
      )

      hideTl.to(
        word,
        {
          opacity: 0,
          duration: 0.2,
        },
        delay + 0.4
      )
    })

    return hideTl
  }

  const animationValues = {
    desktop: {
      introTitleFirstY: '-14rem',
      introTitleSecondY: '14rem',
      introLineScale: 1,
    },
    mobile: {
      introTitleFirstY: '0rem',
      introTitleSecondY: '6rem',
      introLineScale: 1,
    },
  }

  function startAnimation() {
    mainTimeline = gsap.timeline({
      repeat: -1,
      ease: 'power2.out',
    })

    if (window.innerWidth <= 767) {
      mainTimeline
        .to(introTitleFirst, {
          y: animationValues.mobile.introTitleFirstY,
          duration: 1,
        })
        .to(
          introTitleSecond,
          { y: animationValues.mobile.introTitleSecondY, duration: 1 },
          '<'
        )
        .to(
          introLine,
          { scale: animationValues.mobile.introLineScale, duration: 0.6 },
          '<0.2'
        )
    } else {
      mainTimeline
        .to(introTitleFirst, {
          y: animationValues.desktop.introTitleFirstY,
          duration: 1,
        })
        .to(
          introTitleSecond,
          { y: animationValues.desktop.introTitleSecondY, duration: 1 },
          '<'
        )
        .to(
          introLine,
          { scale: animationValues.desktop.introLineScale, duration: 0.6 },
          '<0.2'
        )
    }

    if (allWords) {
      allWords.forEach((word, index) => {
        mainTimeline.add(animateWord(word, 0), `+=0.4`)
      })

      mainTimeline.to({}, { duration: 2 })

      mainTimeline.add(hideAllWords(0))

      mainTimeline
        .to(introTitleFirst, { y: '0rem', duration: 0.8 }, '+=0.3')
        .to(introTitleSecond, { y: '0rem', duration: 0.8 }, '<')
        .to(introLine, { scale: 0, duration: 0.8 }, '<')

      mainTimeline.to({}, { duration: 0.8 })
    }
  }

  if (introTitleFirst.length) {
    startAnimation()
    let resizeTimeout
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(() => {
        if (mainTimeline) {
          mainTimeline.kill()
        }
        startAnimation()
      }, 300)
    })
  }

  function updateHalfContainerWidth() {
    const container = document.querySelector('.container')
    if (!container) return

    const halfWidth = container.offsetWidth / 2 - 15

    document.documentElement.style.setProperty(
      '--half-container-width',
      `${halfWidth}px`
    )
  }

  updateHalfContainerWidth()

  window.addEventListener('resize', updateHalfContainerWidth)

  let lastScrollTop = 0

  $(window).on('scroll', function () {
    const scrollTop = $(this).scrollTop()
    const $header = $('.header')

    if (scrollTop > 100) {
      $header.removeClass('is-shown')
    } else {
      $header.addClass('is-shown')
    }

    if (scrollTop > lastScrollTop) {
      $header.removeClass('is-up').addClass('is-down')
    } else if (scrollTop < lastScrollTop) {
      $header.removeClass('is-down').addClass('is-up')
    }

    lastScrollTop = scrollTop
  })

  $('.btn-burger').on('click', function () {
    $('body').toggleClass('is-menu-open is-ovh')

    const $this = $(this)

    $this.toggleClass('is-active')

    if ($('body').hasClass('is-menu-open')) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  })

  $(document).on('click', function (e) {
    const $target = $(e.target)

    if (
      !$target.closest('.header').length &&
      !$target.closest('.menu').length
    ) {
      $('body').removeClass('is-menu-open is-ovh')
      $('.btn-burger').removeClass('is-active')
    }
  })

  $('.menu__submenu').on('click', function () {
    const $this = $(this)
    const $submenu = $this.find('.menu__links')
    const $submenuNotActive = $('.menu__links').not($submenu)

    $submenu.toggleClass('is-active')
    $submenuNotActive.removeClass('is-active')
  })

  $('.inp-group--search input').on('input', function () {
    const $this = $(this)
    const $parent = $this.closest('.inp-group')

    if ($this.val().length > 0) {
      $parent.addClass('is-filled')
    } else {
      $parent.removeClass('is-filled')
    }
  })

  $('.inp-group__button .btn').on('click', function () {
    const $this = $(this)
    const $parent = $this.closest('.inp-group')
    const $input = $parent.find('.inp-group__input')

    if ($input.val().length > 0) {
      $input.val('')
      $input.trigger('input')
      $parent.removeClass('is-filled')
      $input.focus()
    }
  })

  $('[data-illustration-url]').on('mouseenter', function () {
    const $this = $(this)
    const illustrationUrl = $this.data('illustration-url')

    if (illustrationUrl) {
      $('.industries__photo').prop('src', illustrationUrl)
    }
  })

  $('.cookie__close .btn').on('click', function () {
    const $parent = $(this).closest('.cookie')

    $parent.addClass('is-hidden')
  })

  const eventItems = document.querySelectorAll('.events-item--big')

  eventItems.forEach((item) => {
    const link = item.querySelector('.events-item__title')
    const tags = item.querySelector('.events-item__tags')

    item.addEventListener('click', function (e) {
      if (tags && tags.contains(e.target)) return

      if (link && link.href) {
        window.location.href = link.href
      }
    })
  })

  if (window.matchMedia('(max-width: 767px)').matches) {
    const industriesItems = document.querySelectorAll(
      '.industries-item--column'
    )

    if (industriesItems) {
      industriesItems.forEach((item, index) => {
        const photo = item.querySelector('.industries-item__photo')
        const content = item.querySelector('.industries-item__in')

        gsap.set(photo, {
          scale: 0.8,
          opacity: 0,
        })

        gsap.set(content, {
          y: 30,
          opacity: 0,
        })

        ScrollTrigger.create({
          trigger: item,
          start: 'top 80%',
          onEnter: () => {
            gsap.to(content, {
              y: 0,
              opacity: 1,
              duration: 1.2,
              delay: 0.2 + index * 0.3,
              ease: 'power2.out',
            })

            gsap.to(photo, {
              scale: 1,
              opacity: 1,
              duration: 1.2,
              ease: 'power2.out',
              delay: 0.5 + index * 0.3,
            })
          },
          once: true,
        })
      })
    }
  }

  if ($(window).width() <= 767) {
    $('.events__items--s').slick({
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    })
  }

  // Links for news
  document.querySelectorAll('.news-item__in').forEach((item) => {
    item.addEventListener('click', function (e) {
      const tags = item.querySelector('.news-item__tags')

      if (tags && tags.contains(e.target)) return

      const link = item.querySelector('.news-item__title')
      if (link && link.href) {
        window.location.href = link.href
      }
    })
  })

  $(document).on('click', '.accordeon__headline', function () {
    let parent = $(this).closest('.accordeon')
    const $content = parent.find('.accordeon__in')

    parent.toggleClass('is-active')

    $content.slideToggle(function () {
      // Recalculate the slick container height if the accordion is inside it
      const $slickParent = parent.closest('.article__items.slick-initialized')
      if ($slickParent.length) {
        $slickParent.slick('setPosition')
      }
    })
  })

  $(document).on('click', '.vacancy__favorite', function (event) {
    event.stopPropagation()

    $(this).toggleClass('is-active')
  })

  $(document).on('click', '.vacancy', function () {
    const $item = $(this)
    const $body = $item.find('.vacancy__body')

    if (!$body.length) return

    if ($item.hasClass('is-active')) {
      $body.stop(true, true).slideUp(300, function () {
        $item.removeClass('is-active')
      })
    } else {
      $item.addClass('is-active')
      $body.stop(true, true).slideDown(300)
    }
  })

  // Scroll link
  $(document).on('click', '.anchor', function (event) {
    event.preventDefault()

    $('html, body').animate(
      {
        scrollTop: $($.attr(this, 'href')).offset().top,
      },
      500
    )
  })

  // Tab logic
  let widthTab = $('.nav .active').width()
  let currentTab = $('.nav .active')
    .closest('.nav')
    .find('.tab-status')
    .width(widthTab)

  $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
    let $currentTab = $(e.target).closest('li')
    let $statusTab = $('.nav').find('.tab-status')

    let left = $currentTab.position().left
    let widthTab = $currentTab.width()

    $statusTab.css('left', left)
    $statusTab.width(widthTab)
  })

  // Light gallery
  function initLightGalleryWrapper($wrapper) {
    var $gallery = $wrapper.find('.lightgallery')
    var $mini = $wrapper.find('.lightgallery-mini')

    if (!$gallery.length) return

    var pendingTimer = $wrapper.data('lgInitTimer')
    if (pendingTimer) clearTimeout(pendingTimer)

    // Destroy existing instances
    if ($gallery.hasClass('slick-initialized')) {
      $gallery.slick('unslick')
    }
    if ($mini.length && $mini.hasClass('slick-initialized')) {
      $mini.slick('unslick')
    }
    try {
      var lgData = $gallery.data('lightGallery')
      if (lgData) lgData.destroy(true)
    } catch (e) {}

    $gallery.off('beforeChange.lgSync')
    $mini.off('afterChange.lgSync')

    var lengthThumbs = $mini.find('img').length
    var useCenterMode = lengthThumbs < 5

    var initTimer
    if (lengthThumbs <= 5) {
      $gallery.on(
        'beforeChange.lgSync',
        function (event, slick, currentSlide, nextSlide) {
          $mini.find('.slick-slide').removeClass('slick-current')
          $mini.find('.slick-slide[data-slick-index="' + nextSlide + '"]')
            .addClass('slick-current')
        }
      )

      $mini.on(
        'afterChange.lgSync',
        function (event, slick, currentSlide, nextSlide) {
          $gallery.slick('slickGoTo', currentSlide)
        }
      )

      initTimer = setTimeout(function () {
        $wrapper.removeData('lgInitTimer')

        $gallery.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: false,
          draggable: false,
          variableWidth: false,
        })

        $mini.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          dots: false,
          focusOnSelect: true,
          variableWidth: false,
          centerMode: useCenterMode,
          draggable: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: $gallery,
                dots: false,
                arrows: false,
                focusOnSelect: true,
                draggable: true,
                variableWidth: false,
              },
            },
          ],
        })
      }, 10)
    } else {
      initTimer = setTimeout(function () {
        $wrapper.removeData('lgInitTimer')

        $gallery.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: false,
          asNavFor: $mini,
          draggable: false,
          variableWidth: false,
          infinite: false,
        })

        $mini.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: $gallery,
          dots: false,
          focusOnSelect: true,
          variableWidth: false,
          centerMode: useCenterMode,
          draggable: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: $gallery,
                dots: false,
                arrows: false,
                focusOnSelect: true,
                draggable: true,
                variableWidth: false,
              },
            },
          ],
        })
      }, 10)
    }
    $wrapper.data('lgInitTimer', initTimer)

    if ($(window).width() > 1024) {
      $gallery.lightGallery({
        thumbnail: true,
        showThumbByDefault: false,
        currentPagerPosition: 'left',
        thumbWidth: 100,
        thumbHeight: '100px',
        enableThumbDrag: false,
        pullCaptionUp: false,
        animateThumb: false,
        toogleThumb: true,
      })
    } else {
      $gallery.lightGallery({
        thumbnail: true,
        showThumbByDefault: false,
        thumbWidth: 100,
        thumbHeight: '100px',
        enableThumbDrag: true,
        animateThumb: true,
      })
    }
  }

  window.initLightGallery = function initLightGallery(scope) {
    var $scope = scope ? $(scope) : $(document)

    $scope.find('.lightgallery-wrapper').each(function () {
      initLightGalleryWrapper($(this))
    })
  }

  initLightGallery()

  function copyUrl() {
    var copyText = document.querySelector('.input-url')

    copyText.select()
    copyText.setSelectionRange(0, 99999)

    document.execCommand('copy')
  }

  $(document).on('click', '#lg-copy-url', function () {
    var inputUrl = $('.input-url')
    var url = window.location.href

    inputUrl.val(url)

    copyUrl()

    $('#modal-copy').modal('show')

    setTimeout(function () {
      $('#modal-copy').modal('hide')
    }, 1500)
  })

  $(document).on('click', '.lightgallery-controls--share', function (e) {
    $(this).toggleClass('is-share')
    e.stopPropagation()
  })

  $(document).on('click', '.lightgallery-controls--fullscreen', function (e) {
    e.preventDefault()
    e.stopPropagation()

    $(this).closest('.lightgallery-wrapper').find('.lightgallery .slick-slide.slick-current.slick-active').trigger('click')
  })

  $('.inp-group--select select').styler()

  window.initFileHorizontalLayout = function (root) {
    const container = root || document
    const imgs = container.querySelectorAll('.file__type img')

    imgs.forEach(function (img) {
      function handleImageLoad() {
        const width = img.naturalWidth
        const height = img.naturalHeight

        if (width > height) {
          img.classList.add('img-horizontal')

          const file = img.closest('.file')

          if (file) {
            file.classList.add('file--horizontal')

            const format = file.querySelector('.file__format')
            const type = file.querySelector('.file__type')

            if (format && type) {
              type.appendChild(format)
            }
          }
        }
      }

      if (img.complete) {
        handleImageLoad()
      } else {
        img.onload = handleImageLoad
      }
    })
  }

  window.initFileHorizontalLayout()
})

function initializeStickyAside() {
  if (!window.matchMedia('(min-width: 1025px)').matches) return

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not loaded')
    return
  }

  const pinBlocks = document.querySelectorAll('.news__items')

  pinBlocks.forEach((pinBlock) => {
    if (pinBlock.hasAttribute('data-sticky-initialized')) return

    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize)
    const aside = pinBlock.closest('.aside--sticky')
    const content = aside?.closest('.content__in')

    if (!aside || !content) return

    gsap.set(pinBlock, {
      position: 'relative',
      top: '0',
    })

    ScrollTrigger.create({
      trigger: pinBlock,
      start: `top-=${rem}px top`,
      end: () => {
        const contentRect = content.getBoundingClientRect()
        const scrollTop = window.scrollY || window.pageYOffset
        const contentBottom = scrollTop + contentRect.top + content.offsetHeight
        const pinBlockHeight = pinBlock.offsetHeight
        return contentBottom - pinBlockHeight - rem
      },
      pin: pinBlock,
      pinSpacing: false,
    })

    pinBlock.setAttribute('data-sticky-initialized', 'true')
  })
}

const rem = window.innerWidth * 0.0069

function updateAsideWidthVar() {
  const aside = document.querySelector('.content__aside')
  const contentMain = document.querySelector(
    '.content:not(.content--accent) .content__main'
  )

  if (aside) {
    const asideWidth = aside.offsetWidth + rem * 6.4
    document.documentElement.style.setProperty(
      '--aside-width',
      `-${asideWidth}px`
    )
  }

  if (contentMain) {
    const contentMainWidth = contentMain.offsetWidth
    document.documentElement.style.setProperty(
      '--content-main-width',
      `${contentMainWidth}px`
    )
  }
}

window.addEventListener('DOMContentLoaded', updateAsideWidthVar)

window.addEventListener('resize', () => {
  requestAnimationFrame(updateAsideWidthVar)
})

window.initAsidePaddingXl = function (root) {
  if (window.innerWidth <= 1024) return
  const container = root || document
  container.querySelectorAll('.content').forEach((contentEl) => {
    const hasAccent = contentEl.querySelector('.accent-content')
    const aside = contentEl.querySelector('.content__aside')

    if (hasAccent && aside) {
      contentEl.classList.add('content--accent-inside')
      aside.classList.add('content__aside--padding-xl')
    }
  })
}

window.initAsidePaddingXl()

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('scroll', checkScroll)

  function checkScroll() {
    if (window.innerWidth <= 767) {
      const blocks = document.querySelectorAll('.pt-perspective')
      const lastBlock = blocks[blocks.length - 1]

      if (!lastBlock) return

      if (lastBlock.classList.contains('article-entering')) return

      const rect = lastBlock.getBoundingClientRect()

      if (rect.bottom <= window.innerHeight + 100) {
        const clone = lastBlock.cloneNode(true)

        clone.classList.add('article-entering')

        lastBlock.parentNode.insertBefore(clone, lastBlock.nextSibling)

        setTimeout(() => {
          clone.classList.remove('article-entering')
        }, 400)
      }
    }
  }

  $('.inp-group--phone input').mask('+7 (999) 999-99-99')

  if (document.querySelector('.career-popup') && window.innerWidth > 1024) {
    const popup = document.querySelector('.career-popup')

    ScrollTrigger.create({
      trigger: '.career-page__content',
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: (self) => {
        if (self.progress >= 1 && self.direction === 1) {
          popup.style.position = 'absolute'
          popup.style.bottom = '0'
        } else {
          popup.style.position = 'fixed'
          popup.style.bottom = '0'
        }
      },
    })
  }
})

const filters = []

const containerFilters = document.querySelector('.press-center__filters')

function renderFilters(container, filters) {
  if (!container) return

  const existingBlock = container.querySelector('.filters-choosen')
  if (existingBlock) existingBlock.remove()

  if (!filters || filters.length === 0) return

  const block = document.createElement('div')
  block.className = 'filters-choosen'

  const dateFilterIndex = filters.findIndex((f) => f.type === 'date')
  if (dateFilterIndex !== -1) {
    block.appendChild(createTag(filters[dateFilterIndex], filters, container))
  }

  filters.forEach((filter) => {
    if (filter.type !== 'date') {
      block.appendChild(createTag(filter, filters, container))
    }
  })

  const resetWrapper = document.createElement('div')
  resetWrapper.className = 'filters-choosen__button'

  const resetBtn = document.createElement('button')
  resetBtn.className = 'btn btn-primary-s'
  resetBtn.textContent = 'СБРОСИТЬ ВСЁ'
  resetBtn.addEventListener('click', () => {
    filters.length = 0

    if (window.calendarFilter) {
      window.calendarFilter.resetFilter()
    }

    document
      .querySelectorAll('.filter-popup-tag__input:checked')
      .forEach((input) => {
        input.checked = false
      })

    const url = new URL(window.location.href)
    url.searchParams.delete('date_from')
    url.searchParams.delete('date_to')
    url.searchParams.delete('tags')
    window.history.replaceState({}, '', url.toString())

    renderFilters(container, filters)
  })

  resetWrapper.appendChild(resetBtn)
  block.appendChild(resetWrapper)

  container.prepend(block)
}

function createTag(filter, filters, container) {
  const tag = document.createElement('div')
  tag.className = 'filters-choosen__tag'

  const span = document.createElement('span')
  span.className = 'filters-choosen__value'
  span.textContent = filter.label

  const closeBtn = document.createElement('button')
  closeBtn.className = 'btn btn--close-size-s'
  closeBtn.addEventListener('click', () => {
    const index = filters.indexOf(filter)
    if (index !== -1) filters.splice(index, 1)

    if (filter.type === 'date') {
      if (window.calendarFilter) {
        window.calendarFilter.resetFilter()
      }
      const url = new URL(window.location.href)
      url.searchParams.delete('date_from')
      url.searchParams.delete('date_to')
      window.history.replaceState({}, '', url.toString())
    }

    if (filter.type === 'tag') {
      const tagInputs = document.querySelectorAll('.filter-popup-tag__input')
      tagInputs.forEach((input) => {
        const tagEl = input.closest('.filter-popup-tag')
        const tagText = tagEl?.querySelector('.filter-popup-tag__text')?.textContent.trim()
        if (tagText === filter.label || `#${tagText}` === filter.label) {
          input.checked = false
        }
      })

      const remainingTags = filters
        .filter((f) => f.type === 'tag')
        .map((f) => f.transliteration)
        .filter(Boolean)
      const url = new URL(window.location.href)
      if (remainingTags.length > 0) {
        url.searchParams.set('tags', remainingTags.join(','))
      } else {
        url.searchParams.delete('tags')
      }
      window.history.replaceState({}, '', url.toString())
    }

    renderFilters(container, filters)
  })

  tag.appendChild(span)
  tag.appendChild(closeBtn)

  return tag
}

function getCheckedTags() {
  const checkedInputs = document.querySelectorAll(
    '.filter-popup-tag__input:checked'
  )
  const tags = Array.from(checkedInputs).map((input) => {
    const tagEl = input.closest('.filter-popup-tag')
    return {
      text: tagEl.querySelector('.filter-popup-tag__text').textContent.trim(),
      transliteration: tagEl.getAttribute('data-transliteration-value') || '',
    }
  })
  return tags
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('.filter-popup-calendar__item').length > 0) {
    const calendars = document.querySelectorAll('.filter-popup-calendar__item')
    const applyButton = document.querySelector(
      '.filter-popup__button .js-filter-calendar'
    )
    const FULL_MONTHS = [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ]
    const currentYear = new Date().getFullYear()
    const minYear = 2020

    let state = {
      start: { year: currentYear - 1, months: null },
      end: { year: currentYear, months: null },
    }

    function renderAll() {
      renderYears('start')
      renderYears('end')
      updateMonthsUI('start')
      updateMonthsUI('end')
    }

    function updateMonthsUI(type) {
      const calendarIndex = type === 'start' ? 0 : 1
      const monthCheckboxes = calendars[calendarIndex].querySelectorAll(
        '.filter-popup-calendar__checkbox'
      )
      const monthRange = state[type].months

      monthCheckboxes.forEach((cb, monthIndex) => {
        const input = cb.querySelector('input[type="checkbox"]')
        if (!input) return

        if (monthRange) {
          input.checked =
            monthIndex >= monthRange.first && monthIndex <= monthRange.last
        } else {
          input.checked = false
        }
      })
    }

    function renderYears(type) {
      const calendarIndex = type === 'start' ? 0 : 1
      const calendarEl = calendars[calendarIndex]
      const yearContainer = calendarEl.querySelector(
        '.filter-popup-calendar__values'
      )
      const prevBtn = calendarEl.querySelector(
        '.filter-popup-calendar__button--prev'
      )
      const nextBtn = calendarEl.querySelector(
        '.filter-popup-calendar__button--next'
      )

      // yearContainer.innerHTML = ''
      const selectedYear = state[type].year

      let startRenderYear = selectedYear - 1
      if (selectedYear <= minYear) startRenderYear = minYear
      else if (selectedYear >= currentYear) startRenderYear = currentYear - 2

      for (let i = 0; i < 3; i++) {
        const yearToRender = startRenderYear + i
        if (yearToRender > currentYear || yearToRender < minYear) continue

        const btn = document.createElement('button')
        btn.className = 'btn filter-popup-calendar__value'
        if (yearToRender === selectedYear) btn.classList.add('is-active')
        btn.textContent = yearToRender
        btn.addEventListener('click', () => setYear(type, yearToRender))
        const li = document.createElement('li')
        li.appendChild(btn)
        // yearContainer.appendChild(li)
      }

      // prevBtn.disabled =
      //   (type === 'start' && selectedYear <= minYear) ||
      //   (type === 'end' && selectedYear <= state.start.year + 1)

      // nextBtn.disabled =
      //   (type === 'start' && selectedYear >= currentYear - 1) ||
      //   (type === 'end' && selectedYear >= currentYear)
    }

    function handleMonthClick(type, monthIndex) {
      if (type === 'start') {
        state.start.months = { first: monthIndex, last: monthIndex }
        state.end.months = null
        updateMonthsUI('start')
        updateMonthsUI('end')
      } else {
        if (!state.start.months) {
          return
        }

        state.end.months = { first: 0, last: monthIndex }

        if (state.start.year < state.end.year) {
          const startMonthIndex = state.start.months.first
          state.start.months = { first: startMonthIndex, last: 11 }
        } else if (state.start.year === state.end.year) {
          const nextStart = monthIndex + 1
          if (nextStart <= 11 && state.start.months.first <= monthIndex) {
            state.start.months = { first: nextStart, last: 11 }
          } else {
            state.start.months = null
          }
        }

        updateMonthsUI('start')
        updateMonthsUI('end')
      }
    }

    function clearMonthSelection(type) {
      state[type].months = null
      updateMonthsUI(type)
    }

    function setYear(targetType, newYear) {
      if (state[targetType].year === newYear) return

      state[targetType].year = newYear

      if (targetType === 'start') {
        if (state.end.year < state.start.year + 1) {
          state.end.year = state.start.year + 1
        }
      } else {
        if (state.end.year < state.start.year + 1) {
          state.start.year = state.end.year - 1
        }
      }

      clearMonthSelection('start')
      clearMonthSelection('end')
      renderAll()
    }

    // USE

    function init() {
      calendars.forEach((calendar, idx) => {
        const type = idx === 0 ? 'start' : 'end'
        const prevBtn = calendar.querySelector(
          '.filter-popup-calendar__button--prev'
        )
        const nextBtn = calendar.querySelector(
          '.filter-popup-calendar__button--next'
        )
        const monthCheckboxes = calendar.querySelectorAll(
          '.filter-popup-calendar__checkbox'
        )

        // prevBtn.addEventListener('click', () =>
        //   setYear(type, state[type].year - 1)
        // )
        // nextBtn.addEventListener('click', () =>
        //   setYear(type, state[type].year + 1)
        // )

        monthCheckboxes.forEach((checkbox, monthIndex) => {
          checkbox.addEventListener('click', () =>
            handleMonthClick(type, monthIndex)
          )
        })
      })

      renderAll()
    }

    init()

    $('.js-filter-tags').on('click', function () {
      const activeTags = getCheckedTags()

      for (let i = filters.length - 1; i >= 0; i--) {
        if (filters[i].type === 'tag') {
          filters.splice(i, 1)
        }
      }

      activeTags.forEach((tag) => {
        const label = tag.text.startsWith('#') ? tag.text : `#${tag.text}`
        filters.push({ type: 'tag', label: label, transliteration: tag.transliteration })
      })

      const url = new URL(window.location.href)
      if (activeTags.length > 0) {
        url.searchParams.set('tags', activeTags.map((t) => t.transliteration).join(','))
      } else {
        url.searchParams.delete('tags')
      }
      window.history.replaceState({}, '', url.toString())

      $('.filter-popup').removeClass('is-active')
      $('.filter__select').removeClass('is-opened')

      renderFilters(containerFilters, filters)
    })
  }
})

$('.filter__select').on('click', function () {
  const $parent = $(this).closest('.filter')
  const $popup = $parent.find('.filter-popup')
  const $select = $parent.find('.filter__select')

  $('.filter-popup').not($popup).removeClass('is-active')
  $('.filter__select').not($select).removeClass('is-opened')

  $popup.toggleClass('is-active')
  $select.toggleClass('is-opened')
})

document.body.addEventListener('click', function (e) {
  const filtersBlock = document.querySelector('.filters')
  if (!filtersBlock) return

  if (!filtersBlock.contains(e.target)) {
    document
      .querySelectorAll('.filter-popup.is-active')
      .forEach((el) => el.classList.remove('is-active'))

    document
      .querySelectorAll('.filter__select.is-opened')
      .forEach((el) => el.classList.remove('is-opened'))
  }
})

if ($('.filter-popup').length > 0) {
  class CalendarFilter {
    constructor(container) {
      this.container = container
      this.startDate = null
      this.endDate = null
      this.columnsCount = container.querySelectorAll('.filter-popup-calendar__item').length || 4
      this.currentStartYear = new Date().getFullYear() - (this.columnsCount - 1)

      this.datesContainer = container.querySelector('.filter-popup-dates')
      this.fromSpan = container.querySelector('.filter-popup-dates__from')
      this.toSpan = container.querySelector('.filter-popup-dates__to')
      this.divider = container.querySelector('.filter-popup-dates__divider')
      this.applyBtn = container.querySelector('.js-filter-calendar')
      this.resetBtn = container.querySelector('.js-filter-calendar-reset')
      this.prevBtn = container.querySelector(
        '.filter-popup-calendar__button--prev'
      )
      this.nextBtn = container.querySelector(
        '.filter-popup-calendar__button--next'
      )
      this.filterTitle = container
        .closest('.filter')
        ?.querySelector('.filter__title')

      this.defaultTitle = 'Выберите период'

      this.init()
    }

    init() {
      this.parseUrlParams()
      this.setupMonthsData()
      this.bindEvents()
      this.bindDateInputs()
      this.updateDatesDisplay()
      this.updateResetButtonVisibility()

      this.syncFiltersFromUrl()
    }

    syncFiltersFromUrl() {
      if (this.startDate && this.endDate) {
        this.addDateFilterToFilters(false)
      }

      const params = new URLSearchParams(window.location.search)
      const tagsParam = params.get('tags')
      if (tagsParam) {
        const tags = tagsParam.split(',')
        tags.forEach((tag) => {
          const trimmed = tag.trim()
          if (trimmed) {
            document.querySelectorAll('.filter-popup-tag').forEach((tagEl) => {
              const transliteration = tagEl.getAttribute('data-transliteration-value')
              if (transliteration === trimmed) {
                const input = tagEl.querySelector('.filter-popup-tag__input')
                if (input) input.checked = true
                const text = tagEl.querySelector('.filter-popup-tag__text')?.textContent.trim()
                const label = text && text.startsWith('#') ? text : `#${text}`
                filters.push({ type: 'tag', label: label, transliteration: transliteration })
              }
            })
          }
        })
      }

      if (filters.length > 0 && containerFilters) {
        renderFilters(containerFilters, filters)
      }
    }

    addDateFilterToFilters(shouldRender = true) {
      const existingIndex = filters.findIndex((f) => f.type === 'date')
      if (existingIndex !== -1) {
        filters.splice(existingIndex, 1)
      }

      const fromDate = this.formatDate(this.startDate)
      const toDate = this.endDate ? this.formatDate(this.endDate) : fromDate
      const label = fromDate === toDate ? fromDate : `${fromDate}-${toDate}`

      filters.push({ type: 'date', label: label })

      if (shouldRender && containerFilters) {
        renderFilters(containerFilters, filters)
      }
    }

    parseUrlParams() {
      const params = new URLSearchParams(window.location.search)
      const dateFrom = params.get('date_from')
      const dateTo = params.get('date_to')

      if (dateFrom) {
        this.startDate = this.parseDate(dateFrom)
      }

      if (dateTo) {
        this.endDate = this.parseDate(dateTo)
      }

      if (this.startDate) {
        this.currentStartYear = this.startDate.year - 1
      }
    }

    parseDate(dateStr) {
      const parts = dateStr.split('.')
      if (parts.length === 2) {
        const month = parseInt(parts[0], 10) - 1
        const year = parseInt(parts[1], 10)
        if (!isNaN(month) && !isNaN(year)) {
          return { year: year, month: month }
        }
      }
      return null
    }

    setupMonthsData() {
      const items = this.container.querySelectorAll(
        '.filter-popup-calendar__item'
      )

      items.forEach((item, index) => {
        const year = this.currentStartYear + index

        const headline = item.querySelector('.filter-popup-calendar__headline')
        if (headline) {
          headline.textContent = year
        }

        const listItems = item.querySelectorAll(
          '.filter-popup-calendar__months > li'
        )
        listItems.forEach((li, monthIndex) => {
          const checkbox = li.querySelector('.filter-popup-calendar__checkbox')
          if (checkbox) {
            checkbox.setAttribute('data-year', year)
            checkbox.setAttribute('data-month', monthIndex)
          }
        })
      })

      // Update prev/next button disabled state
      const maxStartYear = new Date().getFullYear() - (this.columnsCount - 1)
      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentStartYear <= 2020
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentStartYear >= maxStartYear
      }

      this.updateSelection()
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.onclick = (e) => {
          e.preventDefault()
          e.stopPropagation()
          if (this.currentStartYear > 2020) {
            this.currentStartYear--
            this.setupMonthsData()
          }
        }
      }

      if (this.nextBtn) {
        this.nextBtn.onclick = (e) => {
          e.preventDefault()
          e.stopPropagation()
          const maxStartYear = new Date().getFullYear() - (this.columnsCount - 1)
          if (this.currentStartYear < maxStartYear) {
            this.currentStartYear++
            this.setupMonthsData()
          }
        }
      }

      const allCheckboxes = this.container.querySelectorAll(
        '.filter-popup-calendar__checkbox'
      )
      allCheckboxes.forEach((checkbox) => {
        checkbox.onclick = (e) => {
          e.preventDefault()
          e.stopPropagation()

          const year = parseInt(checkbox.getAttribute('data-year'), 10)
          const month = parseInt(checkbox.getAttribute('data-month'), 10)

          this.handleMonthClick(year, month)
        }
      })

      if (this.applyBtn) {
        this.applyBtn.onclick = (e) => {
          e.preventDefault()
          e.stopPropagation()
          this.applyFilter()
        }
      }

      if (this.resetBtn) {
        this.resetBtn.onclick = (e) => {
          e.preventDefault()
          e.stopPropagation()
          this.resetFilter()
        }
      }
    }

    bindDateInputs() {
      if (this.fromSpan) {
        this.fromSpan.addEventListener('input', (e) =>
          this.handleDateInput(e, 'start')
        )
        this.fromSpan.addEventListener('blur', (e) =>
          this.validateAndApplyDate(e, 'start')
        )
        this.fromSpan.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            this.validateAndApplyDate(e, 'start')
            this.toSpan?.focus()
          }
        })
      }

      if (this.toSpan) {
        this.toSpan.addEventListener('input', (e) =>
          this.handleDateInput(e, 'end')
        )
        this.toSpan.addEventListener('blur', (e) =>
          this.validateAndApplyDate(e, 'end')
        )
        this.toSpan.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            this.validateAndApplyDate(e, 'end')
          }
        })
      }
    }

    handleDateInput(e, type) {
      let value = e.target.value.replace(/[^\d.]/g, '')

      if (value.length === 2 && !value.includes('.')) {
        value += '.'
      }

      if (value.length > 7) {
        value = value.slice(0, 7)
      }

      e.target.value = value
      e.target.classList.remove('is-invalid')
    }

    clampDate(date) {
      const now = new Date()
      const minYear = 2020, minMonth = 11
      const maxYear = now.getFullYear(), maxMonth = now.getMonth()

      let { year, month } = date

      if (year * 12 + month < minYear * 12 + minMonth) {
        year = minYear
        month = minMonth
      } else if (year * 12 + month > maxYear * 12 + maxMonth) {
        year = maxYear
        month = maxMonth
      }

      return { year, month }
    }

    validateAndApplyDate(e, type) {
      const value = e.target.value
      let parsed = this.parseInputDate(value)

      if (!parsed) {
        if (value.length > 0) {
          e.target.classList.add('is-invalid')
        }
        return
      }

      parsed = this.clampDate(parsed)
      e.target.value = this.formatDate(parsed)
      e.target.classList.remove('is-invalid')

      if (type === 'start') {
        if (this.endDate) {
          const startVal = parsed.year * 12 + parsed.month
          const endVal = this.endDate.year * 12 + this.endDate.month
          if (startVal > endVal) {
            e.target.classList.add('is-invalid')
            return
          }
        }
        this.startDate = parsed
      } else {
        if (this.startDate) {
          const startVal = this.startDate.year * 12 + this.startDate.month
          const endVal = parsed.year * 12 + parsed.month
          if (endVal < startVal) {
            e.target.classList.add('is-invalid')
            return
          }
        }
        this.endDate = parsed
      }

      this.updateSelection()
      this.updateFilterTitle()
      this.updateResetButtonVisibility()
    }

    parseInputDate(value) {
      if (!value || value.length < 7) return null

      const parts = value.split('.')
      if (parts.length !== 2) return null

      const month = parseInt(parts[0], 10) - 1
      const year = parseInt(parts[1], 10)

      if (isNaN(month) || isNaN(year)) return null
      if (month < 0 || month > 11) return null

      return { year, month }
    }

    updateFilterTitle() {
      if (!this.filterTitle) return

      if (!this.startDate) {
        this.filterTitle.innerText = this.defaultTitle
        return
      }

      if (this.endDate) {
        this.filterTitle.innerText =
          this.formatDate(this.startDate) +
          ' — ' +
          this.formatDate(this.endDate)
      } else {
        this.filterTitle.innerText = this.formatDate(this.startDate)
      }
    }

    updateResetButtonVisibility() {
      if (!this.resetBtn) return

      if (this.startDate && this.endDate) {
        this.resetBtn.style.display = ''
      } else {
        this.resetBtn.style.display = 'none'
      }
    }

    resetFilter() {
      this.startDate = null
      this.endDate = null
      this.currentStartYear = new Date().getFullYear() - (this.columnsCount - 1)

      this.setupMonthsData()
      this.updateSelection()
      this.updateDatesDisplay()
      this.updateResetButtonVisibility()

      const dateFilterIndex = filters.findIndex((f) => f.type === 'date')
      if (dateFilterIndex !== -1) {
        filters.splice(dateFilterIndex, 1)
        if (containerFilters) {
          renderFilters(containerFilters, filters)
        }
      }
    }

    isFutureMonth(year, month) {
      const now = new Date()
      const minYear = 2020, minMonth = 11
      const val = year * 12 + month
      if (val < minYear * 12 + minMonth) return true
      return year > now.getFullYear() || (year === now.getFullYear() && month > now.getMonth())
    }

    handleMonthClick(year, month) {
      if (this.isFutureMonth(year, month)) return

      const clickedDate = { year: year, month: month }

      if (
        this.startDate === null ||
        (this.startDate !== null && this.endDate !== null)
      ) {
        this.startDate = clickedDate
        this.endDate = null
      } else {
        const clickedValue = year * 12 + month
        const startValue = this.startDate.year * 12 + this.startDate.month

        if (clickedValue < startValue) {
          this.endDate = this.startDate
          this.startDate = clickedDate
        } else if (clickedValue === startValue) {
          this.endDate = null
        } else {
          this.endDate = clickedDate
        }
      }

      this.updateSelection()
      this.updateDatesDisplay()
    }

    isInRange(year, month) {
      if (!this.startDate) return false

      const currentValue = year * 12 + month
      const startValue = this.startDate.year * 12 + this.startDate.month

      if (!this.endDate) {
        return currentValue === startValue
      }

      const endValue = this.endDate.year * 12 + this.endDate.month
      return currentValue >= startValue && currentValue <= endValue
    }

    updateSelection() {
      const allCheckboxes = this.container.querySelectorAll(
        '.filter-popup-calendar__checkbox'
      )

      allCheckboxes.forEach((checkbox) => {
        const year = parseInt(checkbox.getAttribute('data-year'), 10)
        const month = parseInt(checkbox.getAttribute('data-month'), 10)

        checkbox.classList.remove(
          'is-selected',
          'is-in-range',
          'is-start',
          'is-end',
          'is-future'
        )

        const input = checkbox.querySelector('input')
        if (input) input.checked = false

        if (this.isFutureMonth(year, month)) {
          checkbox.classList.add('is-future')
          return
        }

        if (this.isInRange(year, month)) {
          checkbox.classList.add('is-in-range')
          if (input) input.checked = true
        }

        if (
          this.startDate &&
          this.startDate.year === year &&
          this.startDate.month === month
        ) {
          checkbox.classList.add('is-selected', 'is-start')
        }

        if (
          this.endDate &&
          this.endDate.year === year &&
          this.endDate.month === month
        ) {
          checkbox.classList.add('is-selected', 'is-end')
        }
      })
    }

    updateDatesDisplay() {
      if (!this.datesContainer || !this.fromSpan || !this.toSpan) {
        return
      }

      if (!this.startDate) {
        this.datesContainer.style.opacity = '0'
        this.fromSpan.value = ''
        this.toSpan.value = ''
        this.updateFilterTitle()
        this.updateResetButtonVisibility()
        return
      }

      this.datesContainer.style.opacity = '1'
      this.fromSpan.value = this.formatDate(this.startDate)
      this.fromSpan.classList.remove('is-invalid')

      if (this.endDate) {
        this.toSpan.value = this.formatDate(this.endDate)
        this.toSpan.style.opacity = '1'
        this.toSpan.classList.remove('is-invalid')
        if (this.divider) this.divider.style.opacity = '1'
      } else {
        this.toSpan.value = ''
        this.toSpan.style.opacity = '0'
        if (this.divider) this.divider.style.opacity = '0'
      }

      this.updateFilterTitle()
      this.updateResetButtonVisibility()
    }

    formatDate(date) {
      if (!date) return ''
      const month = String(date.month + 1).padStart(2, '0')
      return month + '.' + date.year
    }

    applyFilter() {
      if (!this.startDate) {
        return
      }

      const fromDate = this.formatDate(this.startDate)
      const toDate = this.endDate ? this.formatDate(this.endDate) : fromDate

      const url = new URL(window.location.href)
      url.searchParams.set('date_from', fromDate)
      url.searchParams.set('date_to', toDate)
      window.history.replaceState({}, '', url.toString())

      this.container.classList.remove('is-active')
      this.container
        .closest('.filter')
        ?.querySelector('.filter__select')
        ?.classList.remove('is-opened')

      this.addDateFilterToFilters()
    }
  }

  function initCalendarFilter() {
    const popup = document.querySelector('.filter-popup')
    if (popup) {
      window.calendarFilter = new CalendarFilter(popup)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalendarFilter)
  } else {
    initCalendarFilter()
  }

  $('.filter-popup__close').on('click', function () {
    const $popup = $(this).closest('.filter-popup')
    $popup.removeClass('is-active')
  })
}

// ARTICLE
if ($('.article__items').length > 0) {
  function setLoading(on) {
    const wrap = document.querySelector('.article__items')
    if (wrap) wrap.classList.toggle('is-loading', !!on)
  }

  const currentDomain = window.location.hostname
  const isDevDomain =
    currentDomain === 'dev.rusnano.com' || currentDomain === 'localhost'

  const DOMAIN_URL = isDevDomain ? 'https://dev.rusnano.com' : ''

  const BASE_URL = `${DOMAIN_URL}/api/news/details/article-content.php`
  const NEWS_LIST_URL = `${DOMAIN_URL}/api/news/`
  const PREVIEW_URL = `${DOMAIN_URL}/api/news/preview/`

  const currentArticleId = $('[data-article-id]').attr('data-article-id')
  const newsListUrl = `${NEWS_LIST_URL}?news_id=${currentArticleId}`

  let loadedPrevCount = 0
  let loadedNextCount = 0
  let allNewsIdList = []
  let currentIndexGlobal = 0

  let isLoadingPrev = false
  let isLoadingNext = false

  let isMobile = false
  let isSlickInitialized = false
  let infiniteScrollObserver = null

  let lastScrollY = 0
  let scrollDirection = 'down'

  const YM_COUNTER_ID = 6972478
  let ymLastUrl = window.location.href

  function ymHit(url, title) {
    const fullUrl = url.indexOf('http') === 0 ? url : window.location.origin + url
    const pageTitle = title || document.title

    if (typeof window.ym !== 'function') {
      console.log('[Метрика] Счётчик не загружен — hit не отправлен:', fullUrl)
      return
    }

    window.ym(YM_COUNTER_ID, 'hit', fullUrl, {
      title: pageTitle,
      referer: ymLastUrl,
    })
    console.log('[Метрика] hit:', fullUrl, '|', pageTitle)
    ymLastUrl = fullUrl
  }

  function ymGoal(goal) {
    if (typeof window.ym !== 'function') {
      console.log('[Метрика] Счётчик не загружен — цель не отправлена:', goal)
      return
    }
    window.ym(YM_COUNTER_ID, 'reachGoal', goal)
    console.log('[Метрика] reachGoal:', goal)
  }

  // OG-разметка добавляем внутрь блока статьи (а не в <head>) - для контентной аналитики Метрики на бесконечной ленте.
  function injectArticleOpenGraph(preview, articleElement) {
    if (!preview || !articleElement) return

    const target = articleElement.querySelector('.article__in') || articleElement
    target.querySelectorAll('meta[data-ym-og]').forEach((m) => m.remove())

    const title = preview.NAME || ''

    let url = ''
    if (preview.URL && preview.URL.includes('/news/')) {
      const slug = preview.URL.replace(/.*\/news\//, '')
      url = window.location.origin + '/news/' + slug
    } else {
      url = window.location.href
    }

    let description = preview.PREVIEW_TEXT || ''
    if (!description) {
      const textEl = articleElement.querySelector(
        '.article__text p, .content__main p'
      )
      if (textEl) description = textEl.textContent.trim().substring(0, 200)
    }

    let image = ''
    const imgEl = articleElement.querySelector(
      '.content img, .iframe-box img, img'
    )
    if (imgEl && imgEl.src) image = imgEl.src

    const ogTags = {
      'og:type': 'article',
      'og:title': title,
      'og:url': url,
      'og:description': description,
    }
    if (image) ogTags['og:image'] = image

    const frag = document.createDocumentFragment()
    for (const prop in ogTags) {
      if (!ogTags[prop]) continue
      const meta = document.createElement('meta')
      meta.setAttribute('property', prop)
      meta.setAttribute('content', ogTags[prop])
      meta.setAttribute('data-ym-og', '')
      frag.appendChild(meta)
    }
    target.insertBefore(frag, target.firstChild)

    console.log('[Метрика] OG-разметка добавлена в блок:', title || articleElement.id || '')
  }

  async function setCurrentArticleIndex(articleId) {
    try {
      const response = await fetch(`${NEWS_LIST_URL}?news_id=${articleId}`)
      const data = await response.json()

      if (data && data.newsIdList) {
        const currentIndex = data.newsIdList.indexOf(articleId.toString())

        const articleElement = document.querySelector(
          `.article__item[data-article-id="${articleId}"]`
        )
        if (articleElement && currentIndex !== -1) {
          articleElement.setAttribute('data-index', currentIndex)
        }
      }
    } catch (error) {
      console.error(`Error getting article index for ${articleId}:`, error)
    }
  }

  if (currentArticleId) {
    setCurrentArticleIndex(currentArticleId)
  }

  const previewCache = new Map()
  async function getArticlePreviewCached(articleId) {
    if (previewCache.has(articleId)) return previewCache.get(articleId)
    const p = getArticlePreview(articleId)
    previewCache.set(articleId, p)
    return p
  }

  function checkIsMobile() {
    return window.innerWidth < 1024
  }

  function formatDate(dateString) {
    if (!dateString) return ''

    const months = [
      'января',
      'февраля',
      'марта',
      'апреля',
      'мая',
      'июня',
      'июля',
      'августа',
      'сентября',
      'октября',
      'ноября',
      'декабря',
    ]

    const dateParts = dateString.split(' ')[0].split('.')
    if (dateParts.length !== 3) return dateString

    const day = parseInt(dateParts[0], 10)
    const month = parseInt(dateParts[1], 10) - 1
    const year = parseInt(dateParts[2], 10)

    if (month < 0 || month > 11 || day < 1 || day > 31) return dateString
    return `${day} ${months[month]} ${year}`
  }

  function processHTML(html) {
    if (currentDomain === 'localhost') {
      return html
        .replace(/src="(?!http|\/\/)([^"]+)"/g, `src="${DOMAIN_URL}$1"`)
        .replace(/src='(?!http|\/\/)([^']+)'/g, `src='${DOMAIN_URL}$1'`)
        .replace(/poster="(?!http|\/\/)([^"]+)"/g, `poster="${DOMAIN_URL}$1"`)
        .replace(/poster='(?!http|\/\/)([^']+)'/g, `poster='${DOMAIN_URL}$1'`)
    }

    return html
  }

  function getArticlePreview(articleId) {
    return fetch(`${PREVIEW_URL}?news_id=${articleId}`)
      .then((response) => {
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`)
        return response.json()
      })
      .then((data) => {
        if (data && data.newsPreview) {
          return data.newsPreview
        } else {
          return null
        }
      })
      .catch((error) => {
        console.error(`Error loading preview for article ${articleId}:`, error)
        return null
      })
  }

  function createTagsHTML(tags) {
    if (!tags || tags.length === 0) return ''

    const validTags = tags.filter((t) => t && t.NAME && t.URL)
    if (validTags.length === 0) return ''

    const tagsHTML = validTags
      .map((tag) => {
        let tagURL = tag.URL
        if (tagURL.startsWith('\\/')) tagURL = tagURL.replace(/\\\//g, '/')
        if (!tagURL.startsWith('http')) {
          if (!tagURL.startsWith('/')) tagURL = '/' + tagURL
        }
        return `<li><a href="${tagURL}" class="article__tag" rel="noindex, nofollow">#${tag.NAME}</a></li>`
      })
      .join('')

    return `<ul class="article__tags">${tagsHTML}</ul>`
  }

  function createPreviewHTML(leftPreview, rightPreview) {
    const leftIndex = leftPreview
      ? allNewsIdList.indexOf(leftPreview.ID || leftPreview.news_id)
      : -1
    const leftIsLast = leftIndex === allNewsIdList.length - 1

    const leftContent = leftPreview
      ? `
    <div class="article-top__accent">
      <h1 class="article__headline">${leftPreview.NAME}</h1>
      <span class="article__date">${formatDate(leftPreview.ACTIVE_FROM)}</span>
      <div class="article-controls dl-menu dl-menuwrapper" id="dl-menu">
        <button class="btn btn--article-prev"></button>
        <button class="btn btn--article-next" ${
          leftIsLast ? 'data-index="last"' : ''
        }></button>
      </div>
    </div>
    ${createTagsHTML(leftPreview.THEMATIC_INDEX)}
  `
      : ''

    const rightIndex = rightPreview
      ? allNewsIdList.indexOf(rightPreview.ID || rightPreview.news_id)
      : -1
    const rightIsLast = rightIndex === allNewsIdList.length - 1

    const rightContent = rightPreview
      ? `
    <div class="article-top__accent">
      <h1 class="article__headline">${rightPreview.NAME}</h1>
      <span class="article__date">${formatDate(rightPreview.ACTIVE_FROM)}</span>
      <div class="article-controls">
        <button class="btn btn--article-prev" data-index="${rightIndex}"></button>
        <button class="btn btn--article-next" ${
          rightIsLast ? 'data-index="last"' : ''
        }></button>
      </div>
    </div>
    ${createTagsHTML(rightPreview.THEMATIC_INDEX)}
  `
      : ''

    return `
    <div class="article__head">
      <div class="article-top">
        <div class="article-top__l">${leftContent}</div>
        <!--noindex-->
        <div class="article-top__r">${rightContent}</div>
        <!--/noindex-->
      </div>
    </div>
  `
  }

  function addEndSentinelIfMissing(itemEl) {
    if (!itemEl.querySelector('.article__end-sentinel')) {
      const s = document.createElement('div')
      s.className = 'article__end-sentinel'
      s.setAttribute('aria-hidden', 'true')
      itemEl.appendChild(s)
    }
  }

  function ensureEndSentinels() {
    document.querySelectorAll('.article__item').forEach(addEndSentinelIfMissing)
  }

  function createArticleStructure(
    html,
    articleId,
    previewHTML = '',
    isNewMobileItem = false
  ) {
    const mobileClass =
      isMobile && isNewMobileItem ? ' article__item-mobile' : ''

    const articleIndex = allNewsIdList.indexOf(articleId.toString())

    return `
    <div class="article__item${mobileClass}" id="${articleId}" data-index="${articleIndex}">
      <div class="article">
        <div class="container">
          <div class="article__in">
            ${previewHTML}
            ${html}
          </div>
        </div>
      </div>
      <div class="article__end-sentinel" aria-hidden="true"></div>
    </div>
  `
  }

  function loadArticle(articleId) {
    return fetch(`${BASE_URL}?news_id=${articleId}`)
      .then((response) => response.text())
      .then((html) => processHTML(html))
  }

  function prependArticle(
    html,
    articleId,
    previewHTML = '',
    isNewMobileItem = false
  ) {
    const articleStructure = createArticleStructure(
      html,
      articleId,
      previewHTML,
      isNewMobileItem
    )
    const container = document.querySelector('.article__items')
    container.insertAdjacentHTML('afterbegin', articleStructure)

    const newElement = document.getElementById(articleId)
    if (newElement) {
      if (window.initFileHorizontalLayout) window.initFileHorizontalLayout(newElement)
      if (window.initAsidePaddingXl) window.initAsidePaddingXl(newElement)
    }

    if (isMobile && isNewMobileItem) {
      if (newElement) {
        setTimeout(() => {
          newElement.classList.add('is-active')
        }, 200)
      } else {
        setTimeout(() => {}, 100)
      }
    }
  }

  function appendArticle(
    html,
    articleId,
    previewHTML = '',
    isNewMobileItem = false
  ) {
    const articleStructure = createArticleStructure(
      html,
      articleId,
      previewHTML,
      isNewMobileItem
    )
    const container = document.querySelector('.article__items')
    container.insertAdjacentHTML('beforeend', articleStructure)

    const newElement = document.getElementById(articleId)
    if (newElement) {
      if (window.initFileHorizontalLayout) window.initFileHorizontalLayout(newElement)
      if (window.initAsidePaddingXl) window.initAsidePaddingXl(newElement)
    }

    if (isMobile && isNewMobileItem) {
      if (newElement) {
        setTimeout(() => {
          newElement.classList.add('is-active')
        }, 200)
      } else {
      }
    }
  }

  function updateBreadcrumbs(articleName) {
    const items = document.querySelectorAll('.breadcrumbs__item')
    if (items.length > 0) {
      const last = items[items.length - 1]
      const textEl = last.querySelector('span') || last
      if (textEl) textEl.textContent = articleName
    }
  }

  function updatePageTitle(title) {
    document.title = title
  }

  function updateOpenGraph(preview, articleElement) {
    if (!preview) return

    var title = preview.NAME || ''
    var url = ''
    if (preview.URL && preview.URL.includes('/news/')) {
      var slug = preview.URL.replace(/.*\/news\//, '')
      url = window.location.origin + '/news/' + slug
    } else {
      url = window.location.href
    }

    var description = ''
    if (preview.PREVIEW_TEXT) {
      description = preview.PREVIEW_TEXT
    } else if (articleElement) {
      var textEl = articleElement.querySelector('.article__text p')
      if (textEl) {
        description = textEl.textContent.trim().substring(0, 200)
      }
    }

    var ogTags = {
      'og:title': title,
      'og:url': url,
      'og:description': description,
    }

    for (var prop in ogTags) {
      if (!ogTags[prop]) continue
      var meta = document.querySelector('meta[property="' + prop + '"]')
      if (meta) {
        meta.setAttribute('content', ogTags[prop])
      } else {
        meta = document.createElement('meta')
        meta.setAttribute('property', prop)
        meta.setAttribute('content', ogTags[prop])
        document.head.appendChild(meta)
      }
    }

    var descMeta = document.querySelector('meta[name="description"]')
    if (descMeta && description) {
      descMeta.setAttribute('content', description)
    }

    document.querySelectorAll('[data-social]').forEach(function (el) {
      el.setAttribute('data-url', url)
      el.setAttribute('data-title', title)
    })

    if (window._goodshare) {
      window._goodshare.reNewAllInstance()
    }
  }

  function updateUrlWithSlug(url, title) {
    if (url && url.includes('/news/')) {
      const slug = url.replace(/.*\/news\//, '')
      const newUrl = `/news/${slug}`

      if (window.location.pathname === newUrl) return

      window.history.replaceState({}, '', newUrl)
      ymHit(newUrl, title)
    }
  }

  async function loadMorePrevArticles() {
    const startIndex = currentIndexGlobal - loadedPrevCount - 1
    const endIndex = startIndex
    let added = 0

    for (let i = startIndex; i >= endIndex; i--) {
      if (i >= 0 && allNewsIdList[i]) {
        try {
          const articleId = allNewsIdList[i]
          const [html, preview] = await Promise.all([
            loadArticle(articleId),
            getArticlePreviewCached(articleId),
          ])

          let rightPreview = null
          if (i < allNewsIdList.length - 1) {
            rightPreview = await getArticlePreviewCached(allNewsIdList[i + 1])
          }

          const previewHTML = createPreviewHTML(preview, rightPreview)

          if (isMobile) {
            prependArticle(html, articleId, previewHTML, true)
          } else {
            prependArticleHidden(html, articleId, previewHTML)
          }

          injectArticleOpenGraph(preview, document.getElementById(articleId))

          loadedPrevCount++
          added++
        } catch (error) {
          console.error(
            `Error loading prev article ${allNewsIdList[i]}:`,
            error
          )
        }
      }
    }

    if (!isMobile && $(container).hasClass('slick-initialized'))
      $(container).slick('setPosition')

    return added
  }

  async function loadMoreNextArticles(count = 1, isInfiniteScroll = false) {
    if (isLoadingNext) return 0

    isLoadingNext = true
    setLoading(true)

    const startIndex = currentIndexGlobal + loadedNextCount + 1
    const endIndex = Math.min(allNewsIdList.length - 1, startIndex + count - 1)
    let added = 0

    for (let i = startIndex; i <= endIndex; i++) {
      if (i < allNewsIdList.length && allNewsIdList[i]) {
        try {
          const articleId = allNewsIdList[i]
          const [html, preview] = await Promise.all([
            loadArticle(articleId),
            getArticlePreviewCached(articleId),
          ])

          let rightPreview = null
          if (i < allNewsIdList.length - 1) {
            rightPreview = await getArticlePreviewCached(allNewsIdList[i + 1])
          }

          const previewHTML = createPreviewHTML(preview, rightPreview)

          if (isMobile) {
            const shouldAddMobileClass = isInfiniteScroll
            appendArticle(html, articleId, previewHTML, shouldAddMobileClass)
            setupInfiniteScroll()
          } else {
            appendArticleHidden(html, articleId, previewHTML)
          }

          injectArticleOpenGraph(preview, document.getElementById(articleId))

          loadedNextCount++
          added++
        } catch (error) {
          console.error(
            `Error loading next article ${allNewsIdList[i]}:`,
            error
          )
        }
      }
    }

    if (!isMobile && $(container).hasClass('slick-initialized'))
      $(container).slick('setPosition')

    setLoading(false)
    isLoadingNext = false
    return added
  }

  function prependArticleHidden(html, articleId, previewHTML = '') {
    const articleStructure = createArticleStructure(
      html,
      articleId,
      previewHTML
    )
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = articleStructure
    const articleElement = tempDiv.firstElementChild

    articleElement.style.display = 'block'

    if (window.initFileHorizontalLayout) window.initFileHorizontalLayout(articleElement)
    if (window.initAsidePaddingXl) window.initAsidePaddingXl(articleElement)

    if ($(container).hasClass('slick-initialized')) {
      $(container).slick('slickAdd', articleElement, 0, true)

      $(container).slick('slickGoTo', 1, true)
      $(container).slick('slickSetOption', 'speed', 300, false)

      setTimeout(() => {
        $(container).slick('slickGoTo', 0, false)
      }, 50)
    } else {
      document
        .querySelector('.article__items')
        .insertAdjacentElement('afterbegin', articleElement)
    }
  }

  function appendArticleHidden(html, articleId, previewHTML = '') {
    const articleStructure = createArticleStructure(
      html,
      articleId,
      previewHTML
    )
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = articleStructure
    const articleElement = tempDiv.firstElementChild

    articleElement.style.display = 'block'

    if (window.initFileHorizontalLayout) window.initFileHorizontalLayout(articleElement)
    if (window.initAsidePaddingXl) window.initAsidePaddingXl(articleElement)

    document
      .querySelector('.article__items')
      .insertAdjacentElement('beforeend', articleElement)

    if ($(container).hasClass('slick-initialized')) {
      $(container).slick('slickAdd', articleElement)
    }
  }

  const container = document.querySelector('.article__items')

  function getAllListIndexById(domId) {
    return allNewsIdList.indexOf(domId.toString())
  }

  function updatePrevBtnDisabled(currentSlideIndex) {
    const disable = currentSlideIndex === 0
    document
      .querySelectorAll('.btn--article-prev')
      .forEach((btn) => btn.classList.toggle('is-disabled', disable))
  }

  const PREV_CHUNK = 1
  const SLIDE_SPEED = 300

  async function goPrevWithPreload() {
    if (isMobile) {
      const items = document.querySelectorAll('.article__item')
      const currentItem = getCurrentVisibleArticle()
      if (currentItem) {
        const currentIndex = Array.from(items).indexOf(currentItem)
        if (currentIndex > 0) {
          items[currentIndex - 1].scrollIntoView({ behavior: 'smooth' })
        }
      }
      return
    }

    const slickObj = $(container)
    const items = document.querySelectorAll('.article__item')
    if (!items.length) return

    let currentSlide = slickObj.slick('slickCurrentSlide')
    if (currentSlide > 0) {
      slickObj.slick('slickPrev')
      return
    }

    const currentSlideElement = items[currentSlide]
    const currentSlideId =
      currentSlideElement?.getAttribute('data-article-id') ||
      currentSlideElement?.id
    if (!currentSlideId) return

    const idxInAll = getAllListIndexById(currentSlideId)
    if (idxInAll === 0) {
      return
    }

    if (isLoadingPrev) return
    isLoadingPrev = true

    try {
      const added = await loadMorePrevArticles()
    } catch (e) {
      console.error(e)
    } finally {
      isLoadingPrev = false
    }
  }

  function getCurrentVisibleArticle() {
    const items = document.querySelectorAll('.article__item')
    let closestItem = null
    let closestDistance = Infinity

    items.forEach((item) => {
      const rect = item.getBoundingClientRect()
      const distance = Math.abs(rect.top)

      if (distance < closestDistance && rect.top < window.innerHeight / 2) {
        closestDistance = distance
        closestItem = item
      }
    })

    return closestItem
  }

  function setupInfiniteScroll() {
    if (infiniteScrollObserver) {
      infiniteScrollObserver.disconnect()
    }

    const items = document.querySelectorAll('.article__item')
    if (items.length === 0) return

    const lastItem = items[items.length - 1]
    const sentinel = lastItem.querySelector('.article__end-sentinel')
    if (!sentinel) return

    infiniteScrollObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const fullyVisible =
            entry.isIntersecting && entry.intersectionRatio >= 1
          if (fullyVisible && !isLoadingNext && scrollDirection === 'down') {
            infiniteScrollObserver.unobserve(entry.target)
            loadMoreNextArticles(1, true)
          }
        })
      },
      {
        root: null,
        threshold: 1.0,
        rootMargin: '0px',
      }
    )

    infiniteScrollObserver.observe(sentinel)
  }

  function handleResize() {
    const wasMobile = isMobile
    isMobile = checkIsMobile()

    if (wasMobile !== isMobile) {
      if (isMobile) {
        if (isSlickInitialized) {
          $(container).slick('unslick')
          isSlickInitialized = false
        }
        setupMobileView()
      } else {
        if (infiniteScrollObserver) {
          infiniteScrollObserver.disconnect()
          infiniteScrollObserver = null
        }
        initializeSlider()
      }
    }
  }

  function setupMobileView() {
    document.querySelectorAll('.article__item').forEach((el) => {
      el.style.display = 'block'
    })

    ensureEndSentinels()

    setupInfiniteScroll()

    let scrollTimeout
    window.addEventListener('scroll', () => {
      if (scrollTimeout) clearTimeout(scrollTimeout)

      scrollTimeout = setTimeout(() => {
        const currentArticle = getCurrentVisibleArticle()
        if (currentArticle) {
          const headline = currentArticle.querySelector('.article__headline')
          if (headline) {
            updateBreadcrumbs(headline.textContent)
            updatePageTitle(headline.textContent)
          }

          getArticlePreviewCached(currentArticle.id).then((preview) => {
            if (preview && preview.URL)
              updateUrlWithSlug(preview.URL, preview.NAME)
            updateOpenGraph(preview, currentArticle)
            injectArticleOpenGraph(preview, currentArticle)
          })
        }
      }, 100)
    })
  }

  function initializeSlider() {
    if (!container) {
      return
    }

    if (isMobile) {
      setupMobileView()
      return
    }

    document
      .querySelectorAll('.article__item')
      .forEach((el) => (el.style.display = 'block'))

    let items = document.querySelectorAll('.article__item')

    let initialSlide = 0
    const currentArticleElement = document.getElementById(currentArticleId)
    if (currentArticleElement) {
      initialSlide = Array.from(items).indexOf(currentArticleElement)
    }

    $(container).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: initialSlide,
      infinite: false,
      arrows: false,
      dots: false,
      fade: false,
      adaptiveHeight: true,
      swipe: false,
      touchMove: false,
      draggable: false,
    })

    isSlickInitialized = true

    $(container).on('afterChange', function (event, slick, currentSlide) {
      if (slick.$slider[0] !== container) return

      items = document.querySelectorAll('.article__item')
      const currentSlideElement = items[currentSlide]
      const currentSlideId = currentSlideElement.id

      const headline = currentSlideElement.querySelector('.article__headline')
      if (headline) updateBreadcrumbs(headline.textContent)
      if (headline) updatePageTitle(headline.textContent)

      getArticlePreviewCached(currentSlideId).then((preview) => {
        if (preview && preview.URL) updateUrlWithSlug(preview.URL, preview.NAME)
        updateOpenGraph(preview, currentSlideElement)
        injectArticleOpenGraph(preview, currentSlideElement)
      })

      window.initLightGallery(currentSlideElement)

      const idxInAll = getAllListIndexById(currentSlideId)
      if (idxInAll === -1) return
      const deltaNext = idxInAll - currentIndexGlobal

      if (!isLoadingNext && loadedNextCount >= 3) {
        const nextTriggerOffset = loadedNextCount - 3 + 1
        if (deltaNext >= nextTriggerOffset) {
          loadMoreNextArticles(3, false)
        }
      }
    })

    $(document).on('click', '.btn--article-prev', async function (e) {
      e.preventDefault()
      await goPrevWithPreload()
    })

    $(document).on('click', '.btn--article-next', function (e) {
      e.preventDefault()
      if (!isMobile) {
        $(container).slick('slickNext')
      }
    })

    $(document).on('keydown', async function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault()
        ymGoal('click-btn-prev')
        await goPrevWithPreload()
      } else if (e.key === 'ArrowRight') {
        e.preventDefault()
        if (!isMobile) {
          ymGoal('click-btn-next')
          $(container).slick('slickNext')
        }
      }
    })

    $(container).slick('slickSetOption', 'speed', 0, false)
    $(container).slick('slickGoTo', initialSlide, true)
    $(container).slick('slickSetOption', 'speed', 300, false)

    items = document.querySelectorAll('.article__item')
    if (items[initialSlide]) {
      window.initLightGallery(items[initialSlide])
    }
  }

  $(document).on('click', '.btn--article-next', function () {
    ymGoal('click-btn-next')
  })
  $(document).on('click', '.btn--article-prev', function () {
    ymGoal('click-btn-prev')
  })

  $(document).ready(function () {
    isMobile = checkIsMobile()

    lastScrollY = window.scrollY
    window.addEventListener(
      'scroll',
      () => {
        const cur = window.scrollY
        scrollDirection = cur > lastScrollY ? 'down' : 'up'
        lastScrollY = cur
      },
      { passive: true }
    )

    $(window).on('resize', handleResize)
  })

  setLoading(true)

  fetch(newsListUrl)
    .then((response) => response.json())
    .then(async (data) => {
      const { newsIdList } = data
      allNewsIdList = newsIdList
      const currentIndex = newsIdList.indexOf(currentArticleId.toString())
      currentIndexGlobal = currentIndex

      getArticlePreviewCached(currentArticleId).then((preview) => {
        const el = document.querySelector(
          `.article__item[data-article-id="${currentArticleId}"]`
        )
        injectArticleOpenGraph(preview, el)
      })

      const nextCount = isMobile ? 1 : 3
      const nextArticleIds = []
      for (let i = 1; i <= nextCount; i++) {
        const nextIndex = currentIndex + i
        if (nextIndex < newsIdList.length)
          nextArticleIds.push(newsIdList[nextIndex])
      }
      loadedPrevCount = 0
      loadedNextCount = nextArticleIds.length

      if (nextArticleIds.length > 0) {
        for (let i = 0; i < nextArticleIds.length; i++) {
          try {
            const articleId = nextArticleIds[i]
            const [html, preview] = await Promise.all([
              loadArticle(articleId),
              getArticlePreviewCached(articleId),
            ])

            let rightPreview = null
            const nextIndex = currentIndex + i + 1 + 1
            if (nextIndex < newsIdList.length) {
              rightPreview = await getArticlePreviewCached(
                newsIdList[nextIndex]
              )
            }

            const previewHTML = createPreviewHTML(preview, rightPreview)

            if (isMobile) {
              appendArticle(html, articleId, previewHTML, false)
            } else {
              appendArticleHidden(html, articleId, previewHTML)
            }

            injectArticleOpenGraph(preview, document.getElementById(articleId))
          } catch (error) {}
        }
      }

      initializeSlider()
      setLoading(false)
    })
    .catch((error) => {
      setLoading(false)
      initializeSlider()
    })
}
